import React, { useEffect, useState } from "react";
import Resume from "../components/Resume/Resume";
import resumePdf from "../files/Ishaan_Sharma_Resume.pdf";
import Skills from "../components/Skills/Skills";
import Experiences from "../components/Experiences/Experiences";

function ResumeContainer(props) {
  const [currentContent, setCurrentContent] = useState("Default");

  let ShowResumeContainer = currentContent === "Skills" ? Skills : Experiences;

  useEffect(() => {
    if (props.forceUpdate === true) {
      setCurrentContent("Default");
      props.forceUpdateFalse();
    }
  }, [props]);

  function handleCurrentContent(resumeDivName) {
    setCurrentContent(resumeDivName);
  }

  return (
    <div className="one-second-animation">
      {currentContent === "Default" ? (
        <div className="containers">
          <h2 className="h2">Resume</h2>
          <h2>
            <a
              href={resumePdf}
              id="PDF-link"
              rel="noopener noreferrer"
              target="_blank"
            >
              Download PDF Version
            </a>
          </h2>
          <Resume handleCurrentContent={handleCurrentContent} />
        </div>
      ) : (
        <div className="containers">
          <div className="one-second-animation full-resume-divs">
            <div className="components">
              <ShowResumeContainer heading={currentContent} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ResumeContainer;
